import { Component } from '@angular/core';

@Component({
  selector: 'di-grid-card-title',
  template: '<ng-content />',
  standalone: false,
})
export class GridCardTitleComponent {}
